import "./../css/sass/styles.scss";

import { debouncer, documentReady, scrollToEl } from "./Utility/utils";
import "./Utility/scroll-smoother";
import "./components/animation";
import "./components/main-navigation";
import "./components/header";
import "./components/video";
import "./components/modal";
import "./components/accordion";
import "./components/two-column-image-content";
import PV from "./Utility/petite-vue";
import "./components/services-slider";
import "./components/testimonials-slider";
import "./components/image-grid";
import "./components/services-navigation";
import "./components/share-bar";
import "./components/articles-search";
import "./components/timeline";
import "./components/tabbed-container";
import 'media-chrome';
import 'vimeo-video-element';
import "./components/contact-page";
import imagesLoaded from "imagesloaded";

// Use this for all your js need
documentReady((event) => {
  // Remove empty p tags accidentally placed by wordpress editor
  var elements = document.querySelectorAll("p");
  Array.prototype.forEach.call(elements, function (el, i) {
    let content = el.innerHTML;
    content = content.replace(/\s+/g, "");
    if (!content) {
      el.parentNode.removeChild(el);
    }
  });

  // Smooth Scrolling Anchor links / Prevent Default on href="#" links
  document.addEventListener(
    "click",
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (var target = e.target; target && target != this; target = target.parentNode) {
        if (target.matches("a")) {
          const href = target.getAttribute("href");
          if (/^#/.test(href)) {
            const hash = href.substring(href.indexOf("#"));
            const hashTarget = document.getElementById(hash.substring(1));
            if (hash !== "#" && hashTarget && !hashTarget.classList.contains('modal')) {
              e.preventDefault();
              target.blur();
              scrollToEl(hashTarget);
            } else if (hash == "#") {
              e.preventDefault();
              target.blur();
            }
          }
          break;
        }
      }
    },
    false
  );
});

window.addEventListener("load", function (event) {
  // Preload images
  const preloadImages = () => {
    return new Promise((resolve, reject) => {
      var imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
          background: true,
        },
        resolve
      );
    });
  };
  preloadImages().then(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    var event = new CustomEvent("pageloaded");
    bodyEl.classList.remove("loading");
    document.dispatchEvent(event);
  });


  PV.mount('body');

});


// hack to fix the 100vh height on mobile ios devices, https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});